export default {"src":"/_webapp/_next/static/media/404NotFound.4f7417e2.svg","height":196,"width":121,"blurWidth":0,"blurHeight":0};